var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.992.285a.713.713 0 0 0-.984 0L.284 10.01a.698.698 0 0 0 .001.983l4.722 4.722a.695.695 0 0 0 .985 0l9.724-9.723a.698.698 0 0 0-.001-.983zM9 2.707L13.293 7 7 13.293 2.707 9zM5.5 14.793L3.707 13l.5-.5-.707-.707-.5.5L1.207 10.5 2 9.707 6.293 14zm8.5-8.5L9.707 2l.793-.793L14.793 5.5zM4 .824L6.058 2.5 4 4.176V3H2.5A1.502 1.502 0 0 0 1 4.5V5H0v-.5A2.503 2.503 0 0 1 2.5 2H4zm8 11v1.177h1.5a1.502 1.502 0 0 0 1.5-1.5V11h1v.5a2.503 2.503 0 0 1-2.5 2.5H12v1.175L9.942 13.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateDevice);
export default __webpack_public_path__ + "static/media/rotate-device.4b1df0817c4a63c9d7954cdb18aa30e9.svg";
export { ForwardRef as ReactComponent };